/* @flow strict */

import * as React from 'react';

type PropsType = {
  handleChangeInput: ({}) => void,
  billRemark: string,
  companyName: string,
  website: string
};

const Organization = ({
  handleChangeInput,
  billRemark,
  companyName,
  website
}: PropsType): React.Element<'form'> => {
  return (
    <>
      <header>
        <h1>Organization information</h1>
        <h4 className="sub-header">
          Make sure your event goers know who you are and where to find you.
        </h4>
      </header>
      <form className='organization-form'>
        <div className='organization-form_name-website'>
        <div className="form-group">
          <label htmlFor="companyName">Your organization's name</label>

          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id='companyName'
              value={companyName}
              onChange={handleChangeInput}
            />
          </div>
        </div>

        <br/>

        <div className="form-group">
          <label htmlFor="website">Your organization's website</label>

          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id='website'
              value={website}
              onChange={handleChangeInput}
            />
          </div>
        </div>
      </div>
        <div className="form-group organization-form_card">
          <label htmlFor="billRemark">Bill statement descriptor</label>

          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id='billRemark'
              value={billRemark}
              onChange={handleChangeInput}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default Organization;
